import React, { useEffect } from "react";
import classes from "./VerifyPhoneOTP.scss";
import CheckOTP from "../CheckOTP/CheckOTP";
import { onEnterOrSpaceKeyDown } from "Utils";
import { useI18n } from "Hooks";

const VerifyPhoneOTP = props => {
  const {
    generateOTPForParent,
    customStyle,
    renderBackButtonComponent,
    data: { phoneNo, otp } = {},
    updateCurrentScreen,
    updateInputField,
    isLoading,
    renderCreateAccountPrivacyText,
    verifyParentOTP,
  } = props;
  const { t } = useI18n(["common"]);

  useEffect(() => {
    if (!phoneNo) {
      generateOTPForParent({ isPhone: true });
    }
  }, []);

  const onBackClick = () => {
    updateCurrentScreen({ type: "forgotPhonePassword" });
    updateInputField({});
  };

  const onResendClick = () => {
    updateInputField({});
    generateOTPForParent({ showMessage: true, isPhone: true });
  };

  const onConfirmClick = () => {
    verifyParentOTP({ isPhone: true });
  };

  const subText = () => {
    return (
      <span>
        We just texted a six-digit code to{" "}
        <span className={classes.phoneText}>
          {phoneNo ? `+${phoneNo}` : ""}
        </span>
        {`. Enter the code below to confirm your phone number. `}
        <span
          className={classes.resendButton}
          onClick={onResendClick}
          onKeyDown={e =>
            onEnterOrSpaceKeyDown(e, () => onResendClick && onResendClick(e))
          }
          role="button"
          tabIndex={0}
          aria-label={t("common:resend_code")}
        >
          Resend Code
        </span>
      </span>
    );
  };

  return (
    <CheckOTP
      renderBackButtonComponent={renderBackButtonComponent}
      onBackClick={onBackClick}
      onConfirmClick={onConfirmClick}
      customStyle={customStyle}
      isLoading={isLoading}
      heading={`Verify your phone number`}
      subHeading={subText}
      renderCreateAccountPrivacyText={renderCreateAccountPrivacyText}
      phoneNo={phoneNo}
      otp={otp}
      onResendClick={onResendClick}
      updateInputField={updateInputField}
    />
  );
};

export default VerifyPhoneOTP;
